import React, { useEffect, useRef, useState } from "react";
import {
    Formik,
    Form,
    Field
} from "formik";
import * as Yup from "yup";

// Formik wrapper to scroll to FIRST error on form submit
import { FormikOnError } from "../Custom-Forms/Formik-On-Error";

import {
    // Image,
    Row,
    Col,
    Container
} from "react-bootstrap";
// import Button from "react-bootstrap/esm/Button";
import Spinner from "react-bootstrap/Spinner";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import { GeneralTextInput } from "../Custom-Forms/General-Text-Input";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
// import { GeneralSelect } from "../Custom-Forms/General-Select";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";



import { setReqID } from "../../store/slices/job-data-slice";
// import { BsPersonSquare } from "react-icons/bs";
// import { IoAddCircleOutline } from "react-icons/io5";
// import { IoIosRemoveCircle } from "react-icons/io";

import { selectedJobData } from "../../store/slices/job-data-slice";
import {
    // selectPostError,
    selectPostStatus
} from "../../store/slices/application-slice";
// import { selectUploadFiles } from "../../store/slices/upload-slice";
import { resetPost } from "../../store/slices/application-slice";

import { postApplication } from "../../store/thunks/post-application-thunk";

// import { FileUpload } from "../File-Upload/File-Upload";
import { ApplicationSubmission } from "./ApplicationSubmission";
import "./ApplicationForm.css";
// import Background from "../Images/cardDesign.png";
import PhoneInput from 'react-phone-number-input'

// import { selectProfileUploadFiles } from "../../store/slices/application-upload-slice";
// import { resetProfileUploadFile } from "../../store/slices/application-upload-slice";

import { selectUploadFiles } from "../../store/slices/upload-slice";
import { resetUploadFile } from "../../store/slices/upload-slice";
import { FileUpload } from "../File-Upload/File-Upload";

import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { IoReturnUpBackOutline } from "react-icons/io5";

import { fetchApplication } from "../../store/thunks/fetch-application-thunk";
import { fetchProfileEmploymentStatus } from "../../store/thunks/fetch-profile-employment-status-thunk";
import { selectApplication, selectRecentApplication } from "../../store/slices/application-slice";
import { selectProfileEmploymentStatus } from "../../store/slices/profile-employment-status-slice";

import Button from "react-bootstrap/Button";

import { asyncLocalStorage } from "../utils/async-localstorage-helpers";

export const ApplicationForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const selectedJob = useSelector(selectedJobData);
    let selectedJob = JSON.parse(localStorage.getItem('storedJob'))
    // const selectedPostError = useSelector(selectPostError);
    const selectedPostStatus = useSelector(selectPostStatus);
    // const selectedUploadFiles = useSelector(selectUploadFiles);
    const uploadPromises = useSelector(selectUploadFiles);
    const recentApplication = useSelector(selectRecentApplication)
    const applicationStatus = useSelector((state) => state.application.status);
    const employmentStatus = useSelector(selectProfileEmploymentStatus)
    const [individualAssessmentIDparam, setIndividualAssessmentIDparam] = useState(false)
    
    // Async function that uses async local storage
    const asyncTempFunction = async () => {
        selectedJob = await asyncLocalStorage.getItem("storedJob").then(job => JSON.parse(job))
    }
    asyncTempFunction()

    const ToastID = React.useRef(null)

    

    // On initial application form load
    // If selected job is empty go to /jobs page and display warning
    useEffect(() => {
        if (
            selectedJob === null || selectedJob.requisitionID === "" 
        ) {
            
            ToastID.current = toast.warning(`No Job Selected. Please Select a Job and Try Again`, {theme: "colored", containerId: "root", autoClose: 5000, position: "top-center"})
            navigate("/jobs");
        }
        setIndividualAssessmentIDparam(selectedJob.isIndividualAssessment)
        if(individualAssessmentIDparam) {
            dispatch(setReqID(individualAssessmentIDparam))
        }
    }, [selectedJob, navigate]);

    useEffect(() => {
        const temp = async() => {
            if (
                selectedJob === null || selectedJob.requisitionID === "" 
            ) {
                ToastID.current = toast.warning(`No Job Selected. Please Select a Job and Try Again`, {theme: "colored", containerId: "root", autoClose: 5000, position: "top-center"})
                navigate("/jobs");
            }
            await dispatch(fetchProfileEmploymentStatus())
            await dispatch(resetPost());
            await dispatch(resetUploadFile());
            ToastID.current = toast.loading(`Attempting to Auto-fill Information from Previous Application`, {theme: "colored", containerId: "root", autoClose: 5000, position: "top-center"})
            await dispatch(fetchApplication())
            
            if(Object.keys(recentApplication).length !== 0) {
                toast.update(ToastID.current , {render: `Successfully Auto-filled Previous Application Information`, type: "success", isLoading: false, theme: "colored", closeOnClick: true, autoClose: 6000, position: "top-center", containerId: "root"})
            } else {
                toast.update(ToastID.current , {render: `Application Auto-fill failed:\n No Previous Application Found`, type: "info", isLoading: false, theme: "colored", closeOnClick: true, autoClose: 6000, position: "top-center", containerId: "root"})
            }
        }
        if(selectedJob !== null) {
            temp()
        }
    }, [])



    
    // If application is a IA, set the req ID to be the IA ID
    // useEffect(() => {
    //     if(individualAssessmentIDparam) {
    //         dispatch(setReqID(individualAssessmentIDparam))
    //     }
    // }, [dispatch, individualAssessmentIDparam])
    
    // Choose what to scroll to when loading in to the page
    const ref = useRef(null);

    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }, [pathname]);



    // Get todays date:
    const date = new Date();
    const todaysDate = date.toLocaleDateString("en-CA");

    let referenceValidationSchema = Yup.object({
        // //Job Related Training #1
        jobRelatedTrainingName1: Yup.string()
            .trim()
            .max(200, "Job Related Training #1 Name too long, 200 Characters Max"),
        jobRelatedTrainingFrom1: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #1 start date Year too large")
            .when("jobRelatedTrainingName1", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #1 start date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingTo1: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #1 end date Year too large")
            .when("jobRelatedTrainingName1", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #1 end date required."),
                otherwise: (schema) => schema
            })
            .when("jobRelatedTrainingFrom1", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #1 end date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingExpirationDate1: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #1 Expiration year too large"),
            // .when("jobRelatedTrainingName1", {
            //     is: (value) => value && value.length !== 0,
            //     then: (schema) => schema.required("Job Related Training #1 expiration date required."),
            //     otherwise: (schema) => schema
            // }),

        jobRelatedTrainingName2: Yup.string()
            .trim()
            .max(200, "Job Related Training #2 Name too long, 200 Characters Max"),
        jobRelatedTrainingFrom2: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #2 start date Year too large")
            .when("jobRelatedTrainingName2", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #2 start date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingTo2: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #2 end date Year too large")
            .when("jobRelatedTrainingName2", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #2 end date required."),
                otherwise: (schema) => schema
            }).when("jobRelatedTrainingFrom2", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #2 end date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingExpirationDate2: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #2 Expiration year too large"),
            // .when("jobRelatedTrainingName2", {
            //     is: (value) => value && value.length !== 0,
            //     then: (schema) => schema.required("Job Related Training #2 expiration date required."),
            //     otherwise: (schema) => schema
            // }),

        jobRelatedTrainingName3: Yup.string()
            .trim()
            .max(200, "Job Related Training #3 Name too long, 200 Characters Max"),
        jobRelatedTrainingFrom3: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #3 start date Year too large")
            .when("jobRelatedTrainingName3", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #3 start date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingTo3: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #3 end date Year too large")
            .when("jobRelatedTrainingName3", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #3 end date required."),
                otherwise: (schema) => schema
            })
            .when("jobRelatedTrainingFrom3", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #3 end date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingExpirationDate3: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #3 Expiration year too large"),
            // .when("jobRelatedTrainingName3", {
            //     is: (value) => value && value.length !== 0,
            //     then: (schema) => schema.required("Job Related Training #3 expiration date required."),
            //     otherwise: (schema) => schema
            // }),

        jobRelatedTrainingName4: Yup.string()
            .trim()
            .max(200, "Job Related Training #4 Name too long, 200 Characters Max"),
        jobRelatedTrainingFrom4: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #4 start date Year too large")
            .when("jobRelatedTrainingName4", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #4 start date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingTo4: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #4 end date Year too large")
            .when("jobRelatedTrainingName4", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #4 end date required."),
                otherwise: (schema) => schema
            })
            .when("jobRelatedTrainingFrom4", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #4 end date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingExpirationDate4: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #4 Expiration year too large"),
            // .when("jobRelatedTrainingName4", {
            //     is: (value) => value && value.length !== 0,
            //     then: (schema) => schema.required("Job Related Training #4 expiration date required."),
            //     otherwise: (schema) => schema
            // }),
        jobRelatedTrainingName5: Yup.string()
            .trim()
            .max(200, "Job Related Training #5 Name too long, 200 Characters Max"),
        jobRelatedTrainingFrom5: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #5 start date Year too large")
            .when("jobRelatedTrainingName5", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #5 start date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingTo5: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #5 end date Year too large")
            .when("jobRelatedTrainingName5", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #5 end date required."),
                otherwise: (schema) => schema
            })
            .when("jobRelatedTrainingFrom5", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #5 end date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingExpirationDate5: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #5 Expiration year too large"),
            // .when("jobRelatedTrainingName5", {
            //     is: (value) => value && value.length !== 0,
            //     then: (schema) => schema.required("Job Related Training #5 expiration date required."),
            //     otherwise: (schema) => schema
            // }),
        jobRelatedTrainingName6: Yup.string()
            .trim()
            .max(200, "Job Related Training #6 Name too long, 200 Characters Max"),
        jobRelatedTrainingFrom6: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #6 start date Year too large")
            .when("jobRelatedTrainingName6", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #6 start date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingTo6: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #6 end date Year too large")
            .when("jobRelatedTrainingName6", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #6 end date required."),
                otherwise: (schema) => schema
            })
            .when("jobRelatedTrainingFrom6", {
                is: (value) => value && value.length !== 0,
                then: (schema) => schema.required("Job Related Training #6 end date required."),
                otherwise: (schema) => schema
            }),
        jobRelatedTrainingExpirationDate6: Yup.date()
            .max(new Date(4000,12,31), "Job Related Training #6 Expiration year too large"),
            // .when("jobRelatedTrainingName6", {
            //     is: (value) => value && value.length !== 0,
            //     then: (schema) => schema.required("Job Related Training #6 expiration date required."),
            //     otherwise: (schema) => schema
            // }),
        // //Job Related Skills
        jobRelatedSkill1: Yup.string()
            .trim()
            .max(200, "Job Related Skill #1 too long, 200 Characters Max"),
        jobRelatedSkill2: Yup.string()
            .trim()
            .max(200, "Job Related Skill #2 too long, 200 Characters Max"),
        jobRelatedSkill3: Yup.string()
            .trim()
            .max(200, "Job Related Skill #3 too long, 200 Characters Max"),
        jobRelatedSkill4: Yup.string()
            .trim()
            .max(200, "Job Related Skill #4 too long, 200 Characters Max"),

        reference1name: Yup.string()
            .trim()
            .max(200, "Reference #1's name is too long, 200 Characters Max")
            .required("Reference #1's name is Required"),
        reference1Address: Yup.string()
            .trim()
            .max(254, "Reference #1's email is too long, 254 Characters Max")
            .email("Enter a valid Email Address.")
            .required("Reference #1's email address is Required"),
        reference1phoneNumber: Yup.string()
            .trim()
            .max(30, "Phone Number too long, 30 Characters Max")
            .required("Reference #1's phone number is Required"),

        reference2name: Yup.string()
            .trim()
            .max(200, "Reference #2's name is too long, 200 Characters Max")
            .required("Reference #2's name is Required"),
        reference2Address: Yup.string()
            .trim()
            .max(254, "Reference #2's email is too long, 254 Characters Max")
            .email("Enter a valid Email Address.")
            .required("Reference #2's email address is Required"),
        reference2phoneNumber: Yup.string()
            .trim()
            .max(30, "Reference #2's phone number is too long, 30 Characters Max")
            .required("Reference #2's phone number is Required"),

        reference3name: Yup.string()
            .trim()
            .max(200, "Reference #3's name is too long, 200 Characters Max")
            .required("Reference #3's name is Required"),
        reference3Address: Yup.string()
            .trim()
            .max(254, "Reference #3's email is too long, 254 Characters Max")
            .email("Enter a valid Email Address.")
            .required("Reference #3's email address is Required"),
        reference3phoneNumber: Yup.string()
            .trim()
            .max(30, "Reference #3's Phone Number is too long, 30 Characters Max")
            .required("Reference #3's phone number is Required"),
        requisitionID: Yup.string().optional(),
        positionTitle: Yup.string().required("Required"),
        positionNumber: Yup.string().required("Required"),
        closingDate: Yup.string().optional(),
        location: Yup.string().required("Required"),
        workHours: Yup.string().optional(),
        workDays: Yup.string().optional(),
        payRate: Yup.string().optional(),
        department: Yup.string().required("Required"),
        employmentType: Yup.string().optional(),
        sensitive: Yup.string().required("Required"),

        // Require a date with the signature in the form MM/DD/YYYY
        signatureDate: Yup.string().required("Signature date is Required"),
        signature: Yup.string()
            .trim()
            .max(10, "10 Characters Max")
            // .matches(
            //     new RegExp('^(1[0-2]|0[1-9])/(3[01]|[12][0-9]|0[1-9])/[0-9]{4}$'),
            //     'Please enter the signature date as MM/DD/YYYY'
            // )
            .required("Signature is Required")
    });

    let content;
    if (selectedPostStatus === "loading") {
        
        content = (
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        );
    } else if (selectedPostStatus === "succeeded") {
        // content = (
        //     <p role="alert" className="text-success">
        //         Application successfully submitted! Redirecting to submitted applications.
        //     </p>
        // );
        toast.update(ToastID.current , {render: `Successfully Applied for: ${selectedJob.positionTitle}`, type: "success", isLoading: false, theme: "colored", closeOnClick: true, autoClose: 5000, position: "top-center", containerId: "root"})
        navigate("/review");
        setTimeout(() => {
            dispatch(resetPost());
        }, 3000)
    } else if (selectedPostStatus === "failed") {
        toast.update(ToastID.current , {render: `Failed to apply for: '${selectedJob.positionTitle}' position. Please Try Again Later`, type: "error", isLoading: false, theme: "colored",  autoClose: 5000, position: "top-center", containerId: "root"})
        // content = (
        //     <p role="alert" className="text-danger">
        //         Error submitting application.
        //     </p>
        // )
    }

    return (
        <>
        { applicationStatus === "loading" && ( 
            <Spinner size="lg" animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        )}
            {applicationStatus === "succeeded" && (
                <Container>
                <Row>
                    <Formik
                        initialValues={{
                            jobRelatedTrainingName1:  recentApplication.Trainings1_Name ? recentApplication.Trainings1_Name : "",
                            jobRelatedTrainingFrom1: recentApplication.Trainings1_From ? recentApplication.Trainings1_From : "",
                            jobRelatedTrainingTo1: recentApplication.Trainings1_To ? recentApplication.Trainings1_To : "",
                            jobRelatedTrainingExpirationDate1: recentApplication.Trainings1_ExpirationDate ? recentApplication.Trainings1_ExpirationDate : "",

                            jobRelatedTrainingName2:  recentApplication.Trainings2_Name ? recentApplication.Trainings2_Name : "",
                            jobRelatedTrainingFrom2: recentApplication.Trainings2_From ? recentApplication.Trainings2_From : "",
                            jobRelatedTrainingTo2: recentApplication.Trainings2_To ? recentApplication.Trainings2_To : "",
                            jobRelatedTrainingExpirationDate2: recentApplication.Trainings2_ExpirationDate ? recentApplication.Trainings2_ExpirationDate : "",

                            jobRelatedTrainingName3:  recentApplication.Trainings3_Name ? recentApplication.Trainings3_Name : "",
                            jobRelatedTrainingFrom3: recentApplication.Trainings3_From ? recentApplication.Trainings3_From : "",
                            jobRelatedTrainingTo3: recentApplication.Trainings3_To ? recentApplication.Trainings3_To : "",
                            jobRelatedTrainingExpirationDate3: recentApplication.Trainings3_ExpirationDate ? recentApplication.Trainings3_ExpirationDate : "",

                            jobRelatedTrainingName4:  recentApplication.Trainings4_Name ? recentApplication.Trainings4_Name : "",
                            jobRelatedTrainingFrom4: recentApplication.Trainings4_From ? recentApplication.Trainings4_From : "",
                            jobRelatedTrainingTo4: recentApplication.Trainings4_To ? recentApplication.Trainings4_To : "",
                            jobRelatedTrainingExpirationDate4: recentApplication.Trainings4_ExpirationDate ? recentApplication.Trainings4_ExpirationDate : "",

                            jobRelatedTrainingName5:  recentApplication.Trainings5_Name ? recentApplication.Trainings5_Name : "",
                            jobRelatedTrainingFrom5: recentApplication.Trainings5_From ? recentApplication.Trainings5_From : "",
                            jobRelatedTrainingTo5: recentApplication.Trainings5_To ? recentApplication.Trainings5_To : "",
                            jobRelatedTrainingExpirationDate5: recentApplication.Trainings5_ExpirationDate ? recentApplication.Trainings5_ExpirationDate : "",

                            jobRelatedTrainingName6:  recentApplication.Trainings6_Name ? recentApplication.Trainings6_Name : "",
                            jobRelatedTrainingFrom6: recentApplication.Trainings6_From ? recentApplication.Trainings6_From : "",
                            jobRelatedTrainingTo6: recentApplication.Trainings6_To ? recentApplication.Trainings6_To : "",
                            jobRelatedTrainingExpirationDate6: recentApplication.Trainings6_ExpirationDate ? recentApplication.Trainings6_ExpirationDate : "",

                            jobRelatedSkill1: recentApplication.Skills1 ? recentApplication.Skills1 : "",
                            jobRelatedSkill2: recentApplication.Skills2 ? recentApplication.Skills2 : "",
                            jobRelatedSkill3: recentApplication.Skills3 ? recentApplication.Skills3 : "",
                            jobRelatedSkill4: recentApplication.Skills4 ? recentApplication.Skills4 : "",

                            signature: "",
                            signatureDate: todaysDate,
                            requisitionID: selectedJob.requisitionID,
                            positionTitle: selectedJob.positionTitle,
                            positionNumber: selectedJob.positionNumber,
                            location: selectedJob.location,
                            closingDate: selectedJob.closingDate,
                            workHours: selectedJob.workHours,
                            workDays: selectedJob.workDays,
                            payRate: selectedJob.payRate,
                            department: selectedJob.department,
                            employmentType: selectedJob.employmentType,
                            sensitive: selectedJob.sensitive,

                            reference1name: recentApplication.Reference1 ? recentApplication.Reference1 : "",
                            reference1Address: recentApplication.Reference1Address ? recentApplication.Reference1Address : "",
                            reference1phoneNumber: recentApplication.Reference1Phone ? recentApplication.Reference1Phone : "",
                            reference2name: recentApplication.Reference2 ? recentApplication.Reference2 : "",
                            reference2Address: recentApplication.Reference2Address ? recentApplication.Reference2Address : "",
                            reference2phoneNumber: recentApplication.Reference2Phone ? recentApplication.Reference2Phone : "",
                            reference3name: recentApplication.Reference3 ? recentApplication.Reference3 : "",
                            reference3Address: recentApplication.Reference3Address ? recentApplication.Reference3Address : "",
                            reference3phoneNumber: recentApplication.Reference3Phone ? recentApplication.Reference3Phone : ""
                            // forms: selectedUploadFiles,
                            // formName: "Additional_Documents"
                        }}
                        validationSchema={referenceValidationSchema}
                        onSubmit={async (values, { setStatus }) => {
                            ToastID.current = toast.loading(`Applying for: ${selectedJob.positionTitle}`, {theme: "colored", containerId: "root", autoClose: 5000})
                            
                            const initialApplication = {
                                jobRelatedTrainingName1:
                                    values.jobRelatedTrainingName1,
                                jobRelatedTrainingFrom1:
                                    values.jobRelatedTrainingFrom1,
                                jobRelatedTrainingTo1:
                                    values.jobRelatedTrainingTo1,
                                jobRelatedTrainingExpirationDate1: 
                                    values.jobRelatedTrainingExpirationDate1,

                                jobRelatedTrainingName2:
                                    values.jobRelatedTrainingName2,
                                jobRelatedTrainingFrom2:
                                    values.jobRelatedTrainingFrom2,
                                jobRelatedTrainingTo2:
                                    values.jobRelatedTrainingTo2,
                                jobRelatedTrainingExpirationDate2: 
                                    values.jobRelatedTrainingExpirationDate2,
                            

                                jobRelatedTrainingName3:
                                    values.jobRelatedTrainingName3,
                                jobRelatedTrainingFrom3:
                                    values.jobRelatedTrainingFrom3,
                                jobRelatedTrainingTo3:
                                    values.jobRelatedTrainingTo3,
                                jobRelatedTrainingExpirationDate3: 
                                    values.jobRelatedTrainingExpirationDate3,

                                jobRelatedTrainingName4:
                                    values.jobRelatedTrainingName4,
                                jobRelatedTrainingFrom4:
                                    values.jobRelatedTrainingFrom4,
                                jobRelatedTrainingTo4:
                                    values.jobRelatedTrainingTo4,
                                jobRelatedTrainingExpirationDate4: 
                                    values.jobRelatedTrainingExpirationDate4,

                                jobRelatedTrainingName5: values.jobRelatedTrainingName5,
                                jobRelatedTrainingFrom5: values.jobRelatedTrainingFrom5,
                                jobRelatedTrainingTo5: values.jobRelatedTrainingTo5,
                                jobRelatedTrainingExpirationDate5: values.jobRelatedTrainingExpirationDate5,

                                jobRelatedTrainingName6: values.jobRelatedTrainingName6,
                                jobRelatedTrainingFrom6: values.jobRelatedTrainingFrom6,
                                jobRelatedTrainingTo6: values.jobRelatedTrainingTo6,
                                jobRelatedTrainingExpirationDate6: values.jobRelatedTrainingExpirationDate6,

                                jobRelatedSkill1: values.jobRelatedSkill1,
                                jobRelatedSkill2: values.jobRelatedSkill2,
                                jobRelatedSkill3: values.jobRelatedSkill3,
                                jobRelatedSkill4: values.jobRelatedSkill4,
                                signatureDate: values.signatureDate,
                                signature: values.signature,
                                // references: tempString,
                                requisitionID: selectedJob.requisitionID,
                                positionTitle: selectedJob.positionTitle,
                                positionNumber: selectedJob.positionNumber,
                                closingDate: selectedJob.closingDate ?? "",
                                location: selectedJob.location,
                                workHours: selectedJob.workHours ?? "",
                                workDays: selectedJob.workDays ?? "",
                                payRate: selectedJob.payRate ?? "",
                                department: selectedJob.department,
                                employmentType: selectedJob.employmentType ?? "",
                                sensitive: selectedJob.sensitive,

                                reference1name: values.reference1name,
                                reference1Address: values.reference1Address,
                                reference1phoneNumber:
                                    values.reference1phoneNumber,
                                reference2name: values.reference2name,
                                reference2Address: values.reference2Address,
                                reference2phoneNumber:
                                    values.reference2phoneNumber,
                                reference3name: values.reference3name,
                                reference3Address: values.reference3Address,
                                reference3phoneNumber:
                                    values.reference3phoneNumber,
                                // forms: selectedUploadFiles,
                                // formName: 'Additional_Documents'
                            };
                            
                            // console.log('Promises: ', uploadPromises.length)
                            if (uploadPromises.length > 0) {
                                const results = await Promise.allSettled(uploadPromises)

                                const hasError = results.some(result => result.status === "rejected")

                                if(hasError) {
                                    setStatus({error: true})
                                    dispatch(resetUploadFile());
                                    toast.error(`Failed to apply for: ${selectedJob.positionTitle} position. Reason: File failed to Upload`, 
                                        {
                                            type: "error",
                                            isLoading: false,
                                            theme: "colored",
                                            autoClose: "6000",
                                            containerId: "root",
                                            position: "top-center",
                                        }
                                    );
                                    // toast.update(ToastID.current , {render: `Failed to apply for: ${selectedJob.positionTitle} position. File failed to Upload`, type: "error", isLoading: false, theme: "colored",  autoClose: 5000, position: "top-center", containerId: "root"})
                                    return
                                }
                                // console.log("UPLOAD finished waiting");
                                dispatch(resetUploadFile());
                                // console.log("UPLOAD promises deleted");
                            }
                            // console.log('POST application start')
                            try {
                                await dispatch(
                                    postApplication(initialApplication)
                                );
                            } catch (error) {
                                setStatus({ error: true });
                                console.error(error);
                                return Promise.reject(error);
                            }

                            if (selectedPostStatus === "failed") {
                                setStatus({ error: true });
                                throw new Error(
                                    "Error submitting application form."
                                );
                            } else if (selectedPostStatus === "succeeded") {
                                setStatus({ error: false });
                                localStorage.removeItem("storedJob")
                                setTimeout(() => {
                                    navigate("/application");
                                }, 5000);
                            }
                        }}
                    >   
                        
                        <Container xss={12} xs={12} xl={12} fluid>
                            <Row xl={12}>
                                <Col xss={12} xs={12} xl={12}>
                                    <Form>
                                        
                                        <FormikOnError>
                                            <Container
                                                className="border-shadow mb-3 rounded-5"
                                                ref={ref}
                                            >
                                                <Row className="py-3 text-center">
                                                    <Col>
                                                        <Button
                                                            variant="primary"
                                                            onClick={() => {
                                                                navigate("/profileCard");
                                                            }}
                                                        >
                                                            <IoReturnUpBackOutline /> Back to Edit Profile
                                                        </Button>
                                                    </Col>
                                                </Row>    
                                                <Row className="rounded-4">
                                                    {individualAssessmentIDparam && (
                                                        <h3 
                                                            aria-hidden="true"
                                                            className="py-3 bg-body-secondary d-inline-block opacity-75 border-bottom border-warning border-5 title-font mb-2 rounded-top-5"
                                                            >
                                                            Individual Assessment for:
                                                        </h3>)
                                                    }

                                                    {!individualAssessmentIDparam && ( 
                                                        <h3
                                                            aria-hidden="true"
                                                            className="py-3 bg-body-secondary d-inline-block opacity-75 border-bottom border-warning border-5 title-font mb-2 rounded-top-5">
                                                            Currently applying for:
                                                        </h3>)
                                                    }
                                                    <Row>

                                                    
                                                        <Row
                                                            
                                                            className="visually-hidden"
                                                            >
                                                                {"Currently applying for " + selectedJob.positionTitle +", " + (individualAssessmentIDparam  ? "Individual Reference ID:" : "Requisition ID:") 
                                                                + selectedJob.requisitionID 
                                                                + (selectedJob.positionNumber ?  ", position number: " + selectedJob.positionNumber : " ")
                                                                + (selectedJob.department ?  ", department: " + selectedJob.department : " ")
                                                                + (selectedJob.location ?  ", location: " + selectedJob.location : " ")
                                                                + (selectedJob.workHours ?  ", work hours: " + selectedJob.positionNumber : " ")
                                                                + (selectedJob.workDays ?  ", work days: " + selectedJob.workDays : " ")
                                                                + (selectedJob.payRate ?  ", pay rate: " + selectedJob.payRate : " ")
                                                                + (selectedJob.employmentType ?  ", employment type: " + selectedJob.employmentType : " ")
                                                                + (selectedJob.sensitive ?  ", sensitive: " + selectedJob.sensitive : " ")
                                                                }
                                                        </Row>

                                                        <Row 
                                                            className="justify-content-center mb-2"
                                                            aria-hidden="true">
                                                            {selectedJob.positionTitle && (<Col
                                                                    xs={12}
                                                                    xl={8}
                                                                    className="mb-2"
                                                                >
                                                                    <GeneralTextInput
                                                                        label="Position Title:"
                                                                        name="positionTitle"
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder={
                                                                            selectedJob.positionTitle
                                                                                ? selectedJob.positionTitle
                                                                                : "N/A"
                                                                        }
                                                                        value={
                                                                            selectedJob.positionTitle
                                                                                ? selectedJob.positionTitle
                                                                                : ""
                                                                        }
                                                                    />
                                                                </Col>)}
                                                            
                                                            <Col
                                                            xs={12}
                                                            xl={8}
                                                            className="mb-2"
                                                            >
                                                                <GeneralTextInput
                                                                    label={individualAssessmentIDparam  ? "Individual Reference ID:" : "Requisition ID:"}
                                                                    name="requisitionID"
                                                                    type="text"
                                                                    disabled={true}
                                                                    placeholder={
                                                                        selectedJob.requisitionID
                                                                            ? selectedJob.requisitionID
                                                                            : "N/A"
                                                                    }
                                                                    aria-label={individualAssessmentIDparam  ? "Selected individual reference ID Field" : "Selected Job Requisition ID field"}
                                                                    value={
                                                                        selectedJob.requisitionID
                                                                            ? selectedJob.requisitionID
                                                                            : ""
                                                                    }
                                                                />
                                                            </Col>
                                                            
                                                            { selectedJob.positionNumber && (<Col
                                                                    xs={12}
                                                                    xl={8}
                                                                    className="mb-2"
                                                                >
                                                                    <GeneralTextInput
                                                                        label="Position Number:"
                                                                        name="positionNumber"
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder={
                                                                            selectedJob.positionNumber
                                                                                ? selectedJob.positionNumber
                                                                                : "N/A"
                                                                        }
                                                                        value={
                                                                            selectedJob.positionNumber
                                                                                ? selectedJob.positionNumber
                                                                                : ""
                                                                        }
                                                                        aria-label="Selected Job Position number"
                                                                    />
                                                                </Col>)}
                                                            { selectedJob.department &&
                                                                (<Col
                                                                    xs={12}
                                                                    xl={8}
                                                                    className="mb-2"
                                                                >
                                                                    <GeneralTextInput
                                                                        label="Department:"
                                                                        name="department"
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder={
                                                                            selectedJob.department
                                                                                ? selectedJob.department
                                                                                : "N/A"
                                                                        }
                                                                        value={
                                                                            selectedJob.department
                                                                                ? selectedJob.department
                                                                                : ""
                                                                        }
                                                                        aria-label="Selected Job department"
                                                                    />
                                                                </Col>)}
                                                            {  selectedJob.location &&  (<Col
                                                                    xs={12}
                                                                    xl={8}
                                                                    className="mb-2"
                                                                >
                                                                    <GeneralTextInput
                                                                        label="Location:"
                                                                        name="location"
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder={
                                                                            selectedJob.location
                                                                                ? selectedJob.location
                                                                                : "N/A"
                                                                        }
                                                                        value={
                                                                            selectedJob.location
                                                                                ? selectedJob.location
                                                                                : ""
                                                                        }
                                                                        aria-label="Selected Job location"
                                                                    />
                                                                </Col>)}
                                                            {!individualAssessmentIDparam && (
                                                                <>
                                                                    { selectedJobData.closingDate && (<Col
                                                                            xs={12}
                                                                            xl={8}
                                                                            className="mb-2"
                                                                        >
                                                                            <GeneralTextInput
                                                                                label="Closing Date:"
                                                                                name="closingDate"
                                                                                type="text"
                                                                                disabled={true}
                                                                                placeholder={
                                                                                    selectedJob.closingDate
                                                                                        ? selectedJob.closingDate
                                                                                        : "N/A"
                                                                                }
                                                                                value={
                                                                                    selectedJob.closingDate
                                                                                        ? selectedJob.closingDate
                                                                                        : ""
                                                                                }
                                                                                aria-label="Selected Job Closing date"
                                                                            />
                                                                        </Col>)}
                                                                    { selectedJob.workHours &&
                                                                        (<Col
                                                                            xs={12}
                                                                            xl={8}
                                                                            className="mb-2"
                                                                        >
                                                                            <GeneralTextInput
                                                                                label="Work Hours:"
                                                                                name="workHours"
                                                                                type="text"
                                                                                disabled={true}
                                                                                placeholder={
                                                                                    selectedJob.workHours
                                                                                        ? selectedJob.workHours
                                                                                        : "N/A"
                                                                                }
                                                                                value={
                                                                                    selectedJob.workHours
                                                                                        ? selectedJob.workHours
                                                                                        : ""
                                                                                }
                                                                                aria-label="Selected Job work hours"
                                                                            />
                                                                        </Col>)}
                                                                    { selectedJob.workDays &&
                                                                        (<Col
                                                                            xs={12}
                                                                            xl={8}
                                                                            className="mb-2"
                                                                        >
                                                                            <GeneralTextInput
                                                                                label="Work Days:"
                                                                                name="workDays"
                                                                                type="text"
                                                                                disabled={true}
                                                                                placeholder={
                                                                                    selectedJob.workDays
                                                                                        ? selectedJob.workDays
                                                                                        : "N/A"
                                                                                }
                                                                                value={
                                                                                    selectedJob.workDays
                                                                                    ? selectedJob.workDays
                                                                                        : ""
                                                                                }
                                                                                aria-label="Selected Job work days"
                                                                            />
                                                                        </Col>)
                                                                    }

                                                                    { selectedJob.payRate && (<Col
                                                                            xs={12}
                                                                            xl={8}
                                                                            className="mb-2"
                                                                        >
                                                                            <GeneralTextInput
                                                                                label="Pay Rate:"
                                                                                name="payRate"
                                                                                type="text"
                                                                                disabled={true}
                                                                                placeholder={
                                                                                    selectedJob.payRate
                                                                                        ? selectedJob.payRate
                                                                                        : "N/A"
                                                                                }
                                                                                value={
                                                                                    selectedJob.payRate
                                                                                        ? selectedJob.payRate
                                                                                        : ""
                                                                                }
                                                                                aria-label="Selected Job location"
                                                                            />
                                                                        </Col>)}
                                                                    
                                                                    { selectedJob.employmentType && (<Col
                                                                        xs={12}
                                                                        xl={8}
                                                                        className="mb-2"
                                                                    >
                                                                        <GeneralTextInput
                                                                            label="Employment Type:"
                                                                            name="employmentType"
                                                                            type="text"
                                                                            disabled={true}
                                                                            placeholder={
                                                                                selectedJob.employmentType
                                                                                    ? selectedJob.employmentType
                                                                                    : "N/A"
                                                                            }
                                                                            value={
                                                                                selectedJob.employmentType
                                                                                    ? selectedJob.employmentType
                                                                                    : ""
                                                                            }
                                                                            aria-label="Selected Job location"
                                                                        />
                                                                    </Col>)}
                                                                </>
                                                            )}
                                                            
                                                            {selectedJob.sensitive && (<Col
                                                                    xs={12}
                                                                    xl={8}
                                                                    className="mb-2"
                                                                >
                                                                    <GeneralTextInput
                                                                        label="Sensitive:"
                                                                        name="sensitive"
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder={
                                                                            selectedJob.sensitive
                                                                                ? selectedJob.sensitive
                                                                                : "N/A"
                                                                        }
                                                                        value={
                                                                            selectedJob.sensitive
                                                                                ? selectedJob.sensitive
                                                                                : ""
                                                                        }
                                                                        aria-label="Selected Job sensitive"
                                                                    />
                                                                </Col>)}
                                                        </Row>
                                                    </Row>
                                                </Row>
                                            </Container>

                                            <br></br>
                                            <Row aria-hidden="true" className="bg-body-secondary rounded-5 py-4 px-4 mb-4">
                                                <Col>
                                                    <h3 className="d-inline-block opacity-75 mt-3 border-bottom border-warning border-5 title-font mb-2">
                                                        Important Notice Regarding User Profile
                                                    </h3>
                                                    <h5 className="fw-bold opacity-75 mb-4 lh-base">
                                                        Every application is submitted with the users profile. 
                                                        The profile only contains the information entered into the web portal. 
                                                        Any paper applications submitted are not included in the web portal. 
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row className="visually-hidden">
                                                Important Notice Regarding User Profile,
                                                Every application is submitted with the users profile. 
                                                The profile only contains the information entered into the web portal. 
                                                Any paper applications submitted are not included in the web portal.
                                            </Row>

                                            <br></br>
                                            <Row aria-hidden="true" className="bg-body-secondary rounded-5 py-4 px-4 mb-4">
                                                <Col>
                                                    <h3 className="d-inline-block opacity-75 mt-3 border-bottom border-warning border-5 title-font mb-2">
                                                        Job Related Skills
                                                    </h3>
                                                    <h5 className="fw-bold opacity-75 mb-4 lh-base">
                                                    Identify four skills relevant to the position you&apos;re applying for, including both hard and soft skills.
                                                        <br></br>
                                                        <strong className="text-danger">
                                                            {" "}
                                                            NOTE:{" "}
                                                        </strong>
                                                        These fields are NOT
                                                        required, so if you wish
                                                        to not list any skills
                                                        you can leave them
                                                        empty.
                                                        <br></br>
                                                    <strong>If you would like to supply any supporting documents please upload them in Additional Documents Tab in the Profile page.</strong>
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row className="visually-hidden">
                                                Job Related Skills,
                                                Identify four skills relevant to the position you&apos;re applying for, including both hard and soft skills.
                                                NOTE:
                                                These fields are NOT
                                                required, so if you wish
                                                to not list any skills
                                                you can leave them
                                                empty.
                                                If you would like to supply any supporting documents please upload them in Additional Documents Tab in the Profile page.
                                            </Row>

                                            <Row className="mx-0">
                                                <Col>
                                                    <GeneralTextAreaField
                                                        warning={recentApplication.Skills1 ? '*Auto-filled': ""}
                                                        label="Job Related Skill #1: "
                                                        maxLength={200}
                                                        className="form-control"
                                                        component="textarea"
                                                        name="jobRelatedSkill1"
                                                        rows="3"
                                                        placeholder="Optional"
                                                        aria-label="Job Related Skill number 1. 200 Characters Max"
                                                        
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            <Row className="mx-0">
                                                <Col>
                                                    <GeneralTextAreaField
                                                        warning={recentApplication.Skills2 ? '*Auto-filled': ""}
                                                        label="Job Related Skill #2: "
                                                        maxLength={200}
                                                        className="form-control"
                                                        component="textarea"
                                                        name="jobRelatedSkill2"
                                                        rows="3"
                                                        placeholder="Optional"
                                                        aria-label="Job Related Skill number 2. 200 Characters Max"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            <Row className="mx-0">
                                                <Col>
                                                    <GeneralTextAreaField
                                                        warning={recentApplication.Skills3 ? '*Auto-filled': ""}
                                                        label="Job Related Skill #3: "
                                                        maxLength={200}
                                                        className="form-control"
                                                        component="textarea"
                                                        name="jobRelatedSkill3"
                                                        rows="3"
                                                        placeholder="Optional"
                                                        aria-label="Job Related Skill number 3. 200 Characters Max"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            <Row className="mx-0 ">
                                                <Col>
                                                    <GeneralTextAreaField
                                                        warning={recentApplication.Skills4 ? '*Auto-filled': ""}
                                                        label="Job Related Skill #4: "
                                                        maxLength={200}
                                                        className="form-control"
                                                        component="textarea"
                                                        name="jobRelatedSkill4"
                                                        rows="3"
                                                        placeholder="Optional"
                                                        aria-label="Job Related Skill number 4. 200 Characters Max"
                                                    />
                                                </Col>
                                            </Row>

                                            <br></br>
                                            <Row aria-hidden="true" className="mx-auto bg-body-secondary rounded-5 py-4 px-4 mb-4">
                                                <Col>
                                                    <h3 className="d-inline-block opacity-75 mt-3 border-bottom border-warning border-5 title-font mb-2">
                                                        Job Related Training
                                                    </h3>
                                                    <h5 className="fw-bold opacity-75 mb-4 lh-base">
                                                    Provide a list of six trainings or certifications relevant to the position you&apos;re applying for. If possible, include all the requested information below for each type of training.
                                                        <br></br>
                                                        <strong className="text-danger">
                                                            NOTE:
                                                        </strong>{" "}
                                                        These fields are not
                                                        required, so if you wish
                                                        to not list any job related trainings
                                                        you can leave them
                                                        empty.
                                                        <br></br>
                                                        <strong>If you would like to supply any supporting documents please upload them in Additional Documents Tab in the Profile page.</strong>
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row className="visually-hidden">
                                                Job Related Training,
                                                Provide a list of six trainings or certifications relevant to the position you&apos;re applying for. If possible, include all the requested information below for each type of training.
                                                NOTE:
                                                These fields are not
                                                required, so if you wish
                                                to not list any job related trainings
                                                you can leave them
                                                empty.
                                                If you would like to supply any supporting documents please upload them in Additional Documents Tab in the Profile.
                                            </Row>
                                            {/* Job related training 1 */}
                                            <Row>
                                                <Row>
                                                    <h4 className="border-bottom border-warning border-5">
                                                        {" "}
                                                        Job related training 1:
                                                    </h4>
                                                </Row>
                                                <Row className="mx-0 mb-2">
                                                    <Col>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings1_Name ? "*Auto-filled" : ""}
                                                            label="Job Related Training Name and Information #1: "
                                                            maxLength={200}
                                                            className="form-control"
                                                            component="textarea"
                                                            name="jobRelatedTrainingName1"
                                                            rows="2"
                                                            placeholder="Training / Certificates"
                                                            aria-label="Job Related Training Name and Information number 1. 200 Characters Max"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings1_From ? "*Auto-filled" : ""}
                                                            label="Training Start #1:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingFrom1"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training start date number 1"
                                                        />
                                                    </Col>
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings1_To ? "*Auto-filled" : ""}
                                                            label="Training End #1:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingTo1"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training end date number 1"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings1_ExpirationDate ? "*Auto-filled" : ""}
                                                            label="Expiration Date #1:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingExpirationDate1"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training expiration date number 1"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5 >
                                                        {" "}
                                                        Upload License/Certificate 1:
                                                    </h5>
                                                </Row>
                                                <FileUpload containerName={
                                                            "Trainings1_Form"
                                                        } />
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            {/* Job related training 2 */}
                                            <Row>
                                                <Row>
                                                    <h4 className="border-bottom border-warning border-5">
                                                        {" "}
                                                        Job related training 2:
                                                    </h4>
                                                </Row>
                                                <Row className="mx-0 mb-2">
                                                    <Col>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings2_Name ? "*Auto-filled" : ""}
                                                            label="Job Related Training Name and Information #2: "
                                                            maxLength={200}
                                                            className="form-control"
                                                            component="textarea"
                                                            name="jobRelatedTrainingName2"
                                                            rows="2"
                                                            placeholder="Training / Certificates"
                                                            aria-label="Job Related Training Name and Information number 2. 200 Characters Max"
                                                        ></GeneralTextAreaField>
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings2_From ? "*Auto-filled" : ""}
                                                            label="Training Start #2:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingFrom2"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training start date number 2"
                                                        ></GeneralTextAreaField>
                                                    </Col>
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings2_To ? "*Auto-filled" : ""}
                                                            label="Training End #2:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingTo2"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training end date number 2"
                                                        ></GeneralTextAreaField>
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings2_ExpirationDate ? "*Auto-filled" : ""}
                                                            label="Expiration Date #2:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingExpirationDate2"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training expiration date number 2"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5 >
                                                        {" "}
                                                        Upload License/Certificate 2: 
                                                    </h5>
                                                </Row>
                                                <FileUpload containerName={
                                                            "Trainings2_Form"
                                                        } />
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            {/* Job related training 3 */}
                                            <Row>
                                                <Row>
                                                    <h4 className="border-bottom border-warning border-5">
                                                        {" "}
                                                        Job related training 3:
                                                    </h4>
                                                </Row>
                                                <Row className="mx-0 mb-2">
                                                    <Col>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings3_Name ? "*Auto-filled" : ""}
                                                            label="Job Related Training Name and Information #3: "
                                                            maxLength={200}
                                                            className="form-control"
                                                            component="textarea"
                                                            name="jobRelatedTrainingName3"
                                                            rows="2"
                                                            placeholder="Training / Certificates"
                                                            aria-label="Job Related Training Name and Information number 3. 200 Characters Max"
                                                        ></GeneralTextAreaField>
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings3_From ? "*Auto-filled" : ""}
                                                            label="Training Start #3:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingFrom3"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training start date number 3"
                                                        />
                                                    </Col>
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings3_To ? "*Auto-filled" : ""}
                                                            label="Training End #3:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingTo3"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training end date number 3"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings3_ExpirationDate ? "*Auto-filled" : ""}
                                                            label="Expiration Date #3:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingExpirationDate3"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training expiration date number 3"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5 >
                                                        {" "}
                                                        Upload License/Certificate 3: 
                                                    </h5>
                                                </Row>
                                                <FileUpload containerName={
                                                            "Trainings3_Form"
                                                        } />
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            {/* Job related training 4 */}
                                            <Row>
                                                <Row>
                                                    <h4 className="border-bottom border-warning border-5">
                                                        {" "}
                                                        Job related training 4:
                                                    </h4>
                                                </Row>
                                                <Row className="mx-0 mb-2">
                                                    <Col>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings4_Name ? "*Auto-filled" : ""}
                                                            label="Job Related Training Name and Information #4: "
                                                            maxLength={200}
                                                            className="form-control"
                                                            component="textarea"
                                                            name="jobRelatedTrainingName4"
                                                            rows="2"
                                                            placeholder="Training / Certificates"
                                                            aria-label="Job Related Training Name and Information number 4. 200 Characters Max"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings4_From ? "*Auto-filled" : ""}
                                                            label="Training Start #4:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingFrom4"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training start date number 4"
                                                        />
                                                    </Col>
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings4_To ? "*Auto-filled" : ""}
                                                            label="Training End #4:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingTo4"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training end date number 4"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings4_ExpirationDate ? "*Auto-filled" : ""}
                                                            label="Expiration Date #4:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingExpirationDate4"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training expiration date number 4"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5 >
                                                        {" "}
                                                        Upload License/Certificate 4:
                                                    </h5>
                                                </Row>
                                                <FileUpload containerName={
                                                            "Trainings4_Form"
                                                        } />
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            {/* Job related training 5 */}
                                            <Row>
                                                <Row>
                                                    <h4 className="border-bottom border-warning border-5">
                                                        {" "}
                                                        Job related training 5:
                                                    </h4>
                                                </Row>
                                                <Row className="mx-0 mb-2">
                                                    <Col>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings5_Name ? "*Auto-filled" : ""}
                                                            label="Job Related Training Name and Information #5: "
                                                            maxLength={200}
                                                            className="form-control"
                                                            component="textarea"
                                                            name="jobRelatedTrainingName5"
                                                            rows="2"
                                                            placeholder="Training / Certificates"
                                                            aria-label="Job Related Training Name and Information number 5. 200 Characters Max"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings5_From ? "*Auto-filled" : ""}
                                                            label="Training Start #5:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingFrom5"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training start date number 5"
                                                        />
                                                    </Col>
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings5_To ? "*Auto-filled" : ""}
                                                            label="Training End #5:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingTo5"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training end date number 5"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings5_ExpirationDate ? "*Auto-filled" : ""}
                                                            label="Expiration Date #5:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingExpirationDate5"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training expiration date number 5"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5 >
                                                        {" "}
                                                        Upload License/Certificate 5:
                                                    </h5>
                                                </Row>
                                                <FileUpload containerName={
                                                            "Trainings5_Form"
                                                        } />
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            {/* Job related training 6 */}
                                            <Row>
                                                <Row>
                                                    <h4 className="border-bottom border-warning border-5">
                                                        {" "}
                                                        Job related training 6:
                                                    </h4>
                                                </Row>
                                                <Row className="mx-0 mb-2">
                                                    <Col>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings6_Name ? "*Auto-filled" : ""}
                                                            label="Job Related Training Name and Information #6: "
                                                            maxLength={200}
                                                            className="form-control"
                                                            component="textarea"
                                                            name="jobRelatedTrainingName6"
                                                            rows="2"
                                                            placeholder="Training / Certificates"
                                                            aria-label="Job Related Training Name and Information number 6. 200 Characters Max"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings6_From ? "*Auto-filled" : ""}
                                                            label="Training Start #6:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingFrom6"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training start date number 6"
                                                        />
                                                    </Col>
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings6_To ? "*Auto-filled" : ""}
                                                            label="Training End #6:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingTo6"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training end date number 6"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mx-0 mb-5 justify-content-evenly">
                                                    <Col xs={12} xl={5}>
                                                        <GeneralTextAreaField
                                                            warning={recentApplication.Trainings6_ExpirationDate ? "*Auto-filled" : ""}
                                                            label="Expiration Date #6:"
                                                            className="form-control"
                                                            type="date"
                                                            name="jobRelatedTrainingExpirationDate6"
                                                            placeholder="MM/DD/YYYY"
                                                            aria-label="Job Related training expiration date number 6"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5 >
                                                        {" "}
                                                        Upload License/Certificate 6:
                                                    </h5>
                                                </Row>
                                                <FileUpload containerName={
                                                            "Trainings6_Form"
                                                        } />
                                                <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                                                    <Row className="justify-content-center border-bottom border-4" />
                                                </Container>
                                            </Row>
                                            <br></br>
                                            <Row aria-hidden="true" className="mx-auto bg-body-secondary rounded-5 py-4 px-4 mb-4">
                                                <Col className="pt-3 ">
                                                    <h3 className="opacity-75 mt-3 border-bottom border-warning border-5 title-font">
                                                        References:
                                                    </h3>
                                                </Col>
                                                <h5 className="fw-bold opacity-75 mb-4 lh-base">
                                                    List three persons who are
                                                    not related to you and who
                                                    have definite knowledge of
                                                    your qualifications for the
                                                    position you are applying
                                                    for.
                                                    <br></br>
                                                    <strong className="text-danger">
                                                        {" "}
                                                        NOTE:{" "}
                                                    
                                                    These fields are
                                                    required.</strong>
                                                </h5>
                                            </Row>
                                            <Row className="visually-hidden">
                                                References,
                                                List three persons who are
                                                not related to you and who
                                                have definite knowledge of
                                                your qualifications for the
                                                position you are applying
                                                for.
                                                NOTE:
                                                These fields are required.
                                            </Row>
                                            <Row className="mb-1 mx-auto">
                                                <Row className="opacity-75 border-bottom border-primary-subtle border-3 py-4 d-flex ">
                                                    <Col>
                                                        <Row className=" mx-0">
                                                            
                                                            <GeneralTextAreaField
                                                                warning={recentApplication.Reference1 ? "*Auto-filled" : ""}
                                                                label="Reference #1 Full Name: (200 Characters Max)"
                                                                className="form-control"
                                                                component="input"
                                                                name="reference1name"
                                                                rows="1"
                                                                placeholder="Full Name"
                                                                aria-label="Reference number one's full name"
                                                            />
                                                        </Row>

                                                        <Row className=" mx-0">
                                                            <GeneralTextAreaField
                                                                warning={recentApplication.Reference1Address ? "*Auto-filled" : ""}
                                                                label="Reference #1 Email Address: (254 Characters Max)"
                                                                className="form-control"
                                                                component="input"
                                                                name="reference1Address"
                                                                rows="1"
                                                                placeholder="name@example.com"
                                                                aria-label="Reference number one's email address"
                                                                aria-required="true"
                                                            />
                                                        </Row>

                                                        <Row className="mx-0">
                                                            <Row>
                                                                <label
                                                                    className="label px-0 mx-0"
                                                                    htmlFor={"reference1phoneNumber"}
                                                                >
                                                                    Reference #1 Phone Number:
                                                                </label>
                                                            </Row>

                                                            <Row>
                                                                <Field name="reference1phoneNumber">
                                                                    {({ field, meta }) => (
                                                                        <div style={{padding: 0}}>
                                                                            <label
                                                                                className=" label px-0 mx-0">
                                                                                { recentApplication.Reference1Phone && <b className="text-success">*Auto-filled</b>}
                                                                            </label>
                                                                            <PhoneInput
                                                                                international
                                                                                countryCallingCodeEditable={
                                                                                    false
                                                                                }
                                                                                defaultCountry="US"
                                                                                placeholder="Enter phone number"
                                                                                aria-required="true"
                                                                                aria-label="Reference number one's phone number"
                                                                                aria-invalid={meta.touched && meta.error ? "true" : null}
                                                                                
                                                                
                                                                                {...field}
                                                                                onChange={(
                                                                                    reference1phoneNumber,
                                                                                ) => {
                                                                                    const changedEvent =
                                                                                        {
                                                                                            target: {
                                                                                                name: "reference1phoneNumber",
                                                                                                value: reference1phoneNumber,
                                                                                            },
                                                                                        };
                                                                                    field.onChange(
                                                                                        changedEvent,
                                                                                    );
                                                                                }}
                                                                            />
                                                                            
                                                                            {meta.touched &&
                                                                                meta.error && (
                                                                                    <div aria-hidden="true" role="status" className="text-danger ">
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            </Row>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <Row className="opacity-75 border-bottom border-primary-subtle border-3 py-4 d-flex ">
                                                    <Col>
                                                        <Row className="mx-0">
                                                            <GeneralTextAreaField
                                                                warning={recentApplication.Reference2 ? "*Auto-filled" : ""}
                                                                label="Reference #2 Full Name: (200 Characters Max)"
                                                                className="form-control"
                                                                component="input"
                                                                name="reference2name"
                                                                rows="1"
                                                                placeholder="Full Name"
                                                                aria-label="Reference number two's full name"
                                                                aria-required="true"
                                                            />
                                                        </Row>

                                                        <Row className="mx-0">
                                                            <GeneralTextAreaField
                                                                warning={recentApplication.Reference2Address ? "*Auto-filled" : ""}
                                                                label="Reference #2 Email Address: (254 Characters Max)"
                                                                className="form-control"
                                                                component="input"
                                                                name="reference2Address"
                                                                rows="1"
                                                                placeholder="name@example.com"
                                                                aria-label="Reference number two's email address"
                                                                aria-required="true"
                                                            />
                                                        </Row>
                                                        
                                                        <Row className="mx-0">
                                                            <Row>
                                                                <label
                                                                    className="label px-0 mx-0"
                                                                    htmlFor={"reference2phoneNumber"}
                                                                >
                                                                    Reference #2 Phone Number:
                                                                </label>
                                                            </Row>

                                                            <Row>
                                                                <Field name="reference2phoneNumber">
                                                                    {({ field, meta }) => (
                                                                        <div style={{padding: 0}}>
                                                                            <label
                                                                                className=" label px-0 mx-0">
                                                                                { recentApplication.Reference2Phone && <b className="text-success">*Auto-filled</b>}
                                                                            </label>
                                                                            <PhoneInput
                                                                                international
                                                                                countryCallingCodeEditable={
                                                                                    false
                                                                                }
                                                                                defaultCountry="US"
                                                                                placeholder="Enter phone number"
                                                                                aria-required="true"
                                                                                aria-label="Reference number two's phone number"
                                                                                aria-invalid={meta.touched && meta.error ? "true" : null}
                                                                                {...field}
                                                                                onChange={(
                                                                                    reference2phoneNumber,
                                                                                ) => {
                                                                                    const changedEvent =
                                                                                        {
                                                                                            target: {
                                                                                                name: "reference2phoneNumber",
                                                                                                value: reference2phoneNumber,
                                                                                            },
                                                                                        };
                                                                                    field.onChange(
                                                                                        changedEvent,
                                                                                    );
                                                                                }}
                                                                            />
                                                                            {meta.touched &&
                                                                                meta.error && (
                                                                                    <div aria-hidden="true" role="status" className="text-danger ">
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            </Row>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row className="opacity-75 border-bottom border-primary-subtle border-3 py-4 d-flex ">
                                                    <Col>
                                                        <Row className="mx-0">
                                                            <GeneralTextAreaField
                                                                warning={recentApplication.Reference3 ? "*Auto-filled" : ""}
                                                                label="Reference #3 Full Name: (200 Characters Max)"
                                                                className="form-control"
                                                                component="input"
                                                                name="reference3name"
                                                                rows="1"
                                                                placeholder="Full Name"
                                                                aria-label="Reference number three's full name"
                                                                aria-required="true"
                                                            />
                                                        </Row>

                                                        <Row className="mx-0">
                                                            <GeneralTextAreaField
                                                                warning={recentApplication.Reference3Address ? "*Auto-filled" : ""}
                                                                label="Reference #3 Email Address: (254 Characters Max)"
                                                                className="form-control"
                                                                component="input"
                                                                name="reference3Address"
                                                                rows="1"
                                                                placeholder="name@example.com"
                                                                aria-label="Reference number three's email address"
                                                                aria-required="true"
                                                            />                                                      
                                                        </Row>

                                                        <Row className="mx-0">
                                                            <Row>
                                                                <label
                                                                    className="label px-0 mx-0"
                                                                    htmlFor={"reference3phoneNumber"}
                                                                >
                                                                    Reference #3 Phone Number:
                                                                </label>
                                                            </Row>

                                                            <Row>
                                                                <Field name="reference3phoneNumber">
                                                                    {({ field, meta }) => (
                                                                        <div style={{padding: 0}}>
                                                                            <label
                                                                                className=" label px-0 mx-0">
                                                                                { recentApplication.Reference3Phone && (field.value === meta.initialValue) && <b className="text-success">*Auto-filled</b>}
                                                                            </label>
                                                                            <PhoneInput
                                                                                international
                                                                                countryCallingCodeEditable={
                                                                                    false
                                                                                }
                                                                                defaultCountry="US"
                                                                                placeholder="Enter phone number"
                                                                                aria-required="true"
                                                                                aria-label="Reference number three's phone number"
                                                                                aria-invalid={meta.touched && meta.error ? "true" : null}
                                                                                {...field}
                                                                                onChange={(
                                                                                    reference3phoneNumber,
                                                                                ) => {
                                                                                    const changedEvent =
                                                                                        {
                                                                                            target: {
                                                                                                name: "reference3phoneNumber",
                                                                                                value: reference3phoneNumber,
                                                                                            },
                                                                                        };
                                                                                    field.onChange(
                                                                                        changedEvent,
                                                                                    );
                                                                                }}
                                                                            />
                                                                            {meta.touched &&
                                                                                meta.error && (
                                                                                    <div aria-hidden="true" role="status" className="text-danger ">
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            </Row>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Row>

                                            <Row aria-hidden="true" className="mx-auto bg-body-secondary rounded-5 py-4 px-4 mb-4">
                                                <Col className="pt-3 ">
                                                    <h3 className="opacity-75 mt-3 border-bottom border-warning border-5 title-font">
                                                        Pre-Employment Agreement:
                                                    </h3>
                                                </Col>
                                            </Row>
                                            <Row
                                                aria-hidden="true" 
                                                className="justify-content-center">
                                                <Col xl={11}>
                                                    <h6 
                                                        className="text-danger text-center fw-bold fs-8 line-height"
                                                        >
                                                        THE INFORMATION THAT I
                                                        HAVE PROVIDED ON THIS
                                                        APPLICATION IS TRUE AND
                                                        COMPLETE TO THE BEST OF
                                                        MY KNOWLEDGE. ANY
                                                        MISREPRESENTATION OR
                                                        OMISSION OF ANY FACT IN
                                                        MY APPLICATION, OR ANY
                                                        OTHER MATERIALS USED IN
                                                        THE APPLICATION PROCESS,
                                                        OR INFORMATION OFFERED
                                                        DURING ANY INTERVIEWS,
                                                        CAN BE JUSTIFICATION FOR
                                                        REFUSAL OF EMPLOYMENT,
                                                        OR IF EMPLOYED,
                                                        TERMINATION FROM
                                                        EMPLOYMENT WITH THE
                                                        NAVAJO NATION. MY
                                                        SIGNATURE BELOW
                                                        AUTHORIZES THE NAVAJO
                                                        NATION TO CONTACT ANY OF
                                                        MY PRIOR EMPLOYERS FOR
                                                        REFERENCE PURPOSES. I
                                                        UNDERSTAND THAT I MAY BE
                                                        SUBJECT TO A BACKGROUND
                                                        CHECK, AND HEREBY
                                                        AUTHORIZE NAVAJO NATION
                                                        TO INVESTIGATE MY
                                                        BACKGROUND TO DETERMINE
                                                        ANY AND ALL INFORMATION
                                                        OF CONCERN AS TO MY
                                                        RECORD, WHETHER SAME IS
                                                        OF RECORD OR NOT, AND I
                                                        RELEASE EMPLOYERS AND
                                                        PERSONS NAMED IN MY
                                                        APPLICATION FROM ALL
                                                        LIABILITY FOR ANY
                                                        DAMAGES ON ACCOUNT OF
                                                        HIS/HER FURNISHING SAID
                                                        INFORMATION.
                                                        ADDITIONALLY, YOU ARE
                                                        HEREBY AUTHORIZED TO
                                                        MAKE ANY INVESTIGATION
                                                        OF MY PERSONAL HISTORY,
                                                        EDUCATIONAL BACKGROUND,
                                                        MILITARY RECORD, MOTOR
                                                        VEHICLE RECORDS,
                                                        CRIMINAL RECORDS AND
                                                        CREDIT HISTORY THROUGH
                                                        AN INVESTIGATIVE OR
                                                        CREDIT AGENCY OR BUREAU
                                                        OF YOUR CHOICE. I
                                                        AUTHORIZE THE RELEASE OF
                                                        THIS INFORMATION BY THE
                                                        APPROPRIATE AGENCIES TO
                                                        THE INVESTIGATING
                                                        SERVICE.
                                                    </h6>
                                                </Col>
                                            </Row>

                                            <Row
                                                className="visually-hidden">
                                                Pre-Employment Agreement:
                                                THE INFORMATION THAT I
                                                HAVE PROVIDED ON THIS
                                                APPLICATION IS TRUE AND
                                                COMPLETE TO THE BEST OF
                                                MY KNOWLEDGE. ANY
                                                MISREPRESENTATION OR
                                                OMISSION OF ANY FACT IN
                                                MY APPLICATION, OR ANY
                                                OTHER MATERIALS USED IN
                                                THE APPLICATION PROCESS,
                                                OR INFORMATION OFFERED
                                                DURING ANY INTERVIEWS,
                                                CAN BE JUSTIFICATION FOR
                                                REFUSAL OF EMPLOYMENT,
                                                OR IF EMPLOYED,
                                                TERMINATION FROM
                                                EMPLOYMENT WITH THE
                                                NAVAJO NATION. MY
                                                SIGNATURE BELOW
                                                AUTHORIZES THE NAVAJO
                                                NATION TO CONTACT ANY OF
                                                MY PRIOR EMPLOYERS FOR
                                                REFERENCE PURPOSES. I
                                                UNDERSTAND THAT I MAY BE
                                                SUBJECT TO A BACKGROUND
                                                CHECK, AND HEREBY
                                                AUTHORIZE NAVAJO NATION
                                                TO INVESTIGATE MY
                                                BACKGROUND TO DETERMINE
                                                ANY AND ALL INFORMATION
                                                OF CONCERN AS TO MY
                                                RECORD, WHETHER SAME IS
                                                OF RECORD OR NOT, AND I
                                                RELEASE EMPLOYERS AND
                                                PERSONS NAMED IN MY
                                                APPLICATION FROM ALL
                                                LIABILITY FOR ANY
                                                DAMAGES ON ACCOUNT OF
                                                HIS/HER FURNISHING SAID
                                                INFORMATION.
                                                ADDITIONALLY, YOU ARE
                                                HEREBY AUTHORIZED TO
                                                MAKE ANY INVESTIGATION
                                                OF MY PERSONAL HISTORY,
                                                EDUCATIONAL BACKGROUND,
                                                MILITARY RECORD, MOTOR
                                                VEHICLE RECORDS,
                                                CRIMINAL RECORDS AND
                                                CREDIT HISTORY THROUGH
                                                AN INVESTIGATIVE OR
                                                CREDIT AGENCY OR BUREAU
                                                OF YOUR CHOICE. I
                                                AUTHORIZE THE RELEASE OF
                                                THIS INFORMATION BY THE
                                                APPROPRIATE AGENCIES TO
                                                THE INVESTIGATING
                                                SERVICE.
                                            </Row>

                                            <Row aria-hidden="true" className="justify-content-start bg-body-secondary rounded-5 py-4 px-4 mb-4">
                                                <Col className="py-0">
                                                    <h3
                                                        className="opacity-75  mt-3 border-bottom border-warning border-5 title-font">
                                                            Application Signature:
                                                    </h3>
                                                </Col>
                                            </Row>
                                            <Row className=" mt-2 mx-auto">
                                                <Row className="mx-0 d-flex justify-content-evenly">
                                                    <Col
                                                        className="justify-content-start"
                                                        xs={12}
                                                        xl={5}
                                                    >
                                                        <GeneralTextAreaField
                                                            label="Enter your Initials: (10 Characters Max)"
                                                            className="form-control"
                                                            component="input"
                                                            name="signature"
                                                            rows="1"
                                                            placeholder="XX"
                                                            aria-label="Applicants signature Initials 10 Characters Max"
                                                            aria-required="true"
                                                            
                                                        />
                                                    </Col>
                                                    {/* <GeneralTextInput
                                                    label="Enter your Initials"
                                                    name="signature"
                                                    type="text"
                                                    placeholder=""
                                                /> */}
                                                    <Col
                                                        className="mx-0 d-flex justify-content-end"
                                                        xs={12}
                                                        xl={5}
                                                    >
                                                        {/* <GeneralTextInput
                                                        label="Signature Date"
                                                        name="signatureDate"
                                                        type="date"
                                                        placeholder="Date of Signature: MM/DD/YYYY"
                                                        value={todaysDate}
                                                        disabled={true}
                                                    /> */}
                                                        <GeneralTextAreaField
                                                            label="Signature Date: (Today)"
                                                            name="signatureDate"
                                                            type="date"
                                                            value={todaysDate}
                                                            disabled={true}
                                                            placeholder="mm/dd/yyyy"
                                                            aria-label="Today's date, auto-filled, "
                                                            aria-required="true"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Row>
                                            <Row className="text-center mb-5 mt-3">
                                                {content}
                                                <ApplicationSubmission className="btn-lg" props={{employmentStatus, selectedJob}} />
                                            </Row>
                                        </FormikOnError>
                                    </Form>
                                </Col>
                            </Row>
                        </Container>
                    </Formik>
                </Row>
            </Container>
            )}
            
        </>
    );
};
